import { LOG_IN, LOG_OUT } from '../actions/user';
import type { UserAction, UserState } from '../types/user';

export const initialState: UserState = {
    isLoggedIn: false,
    user: null,
};

export const userReducer = (state: UserState, action: UserAction): UserState => {
    switch (action.type) {
        case LOG_IN:
            return {
                isLoggedIn: true,
                user: action.payload,
            };
        case LOG_OUT:
            return {
                isLoggedIn: false,
                user: null,
            };
        default:
            return state;
    }
};
